import React from 'react';
import { connect } from 'react-redux';
import { main } from '../state/actions';
import GLOBAL_STYLES from '../styles';
import { Credentials } from 'aws-sdk';
import { Form, Button } from 'react-bootstrap';
import * as CONSTANTS from '../config';
import { getPackageVersion } from '../helpers/misc';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  loadingMessage: state.main.loadingMessage,
});

const mapDispatchToProps = dispatch => ({
  updateCredentials: payload => dispatch(main.updateCredentials(payload)),
  updateLastActivity: payload => dispatch(main.updateLastActivity(payload)),
  updateLoadingMessage: payload => dispatch(main.updateLoadingMessage(payload)),
  updateColorScheme: payload => dispatch(main.updateColorScheme(payload)),
});


class Login extends React.Component {
  constructor(props) {
    super(props);
    this._NIFCOAuth = props.NIFCOAuth;
    this.state = {
      userTypeInputValue: props.NIFCOAuth.userType,
      usernameInputValue: '',
      passwordInputValue: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.authenticatePasswordUser = this.authenticatePasswordUser.bind(this);
    this.changeUserType = this.changeUserType.bind(this);
    this.setInputsToError = this.setInputsToError.bind(this);
  }

  authenticatePasswordUser = async (e,username,password,userType) => {
    e.preventDefault();
    const { userTypeInputValue } = this.state;
    try {
      if(username == null || username.length === 0 ||
        password == null || password.length === 0) return;
      this.props.updateLoadingMessage('Authenticating');
      userType = userType != null ? userType : userTypeInputValue;
      this._NIFCOAuth.userType = userType;
      const authData = await this._NIFCOAuth.authenticateUser(username, password);
      if(authData == null || authData.credentials == null) {
        this.setInputsToError();
        this.props.updateLoadingMessage(null);
        return;
      }

      // clear input states
      this.setState({
        usernameInputValue: '',
        passwordInputValue: '',
      });

      // add aws credentials to local storage
      sessionStorage.setItem(`com.nifconet.${CONSTANTS.APP_ID}.credentials`, JSON.stringify({
        ...authData,
        userType: userType,
      }));

      // update main state
      this.props.updateLastActivity();
      this.props.updateLoadingMessage(null);
      this.props.updateCredentials({
        credentials: new Credentials(authData.credentials.AccessKeyId, authData.credentials.SecretAccessKey, authData.credentials.SessionToken),
        credentialsExpirationTime: Date.parse(authData.credentials.Expiration),
        authorizedModules: authData.authorizedModules,
        loggedInUser: authData.user,
        userType: userType,
      });
    }
    catch(e) {
      console.error('authenticatePasswordUser error:', e);
      this.setInputsToError();
      this.props.updateLoadingMessage(null);
    }
  };

  setInputsToError = () => this.setState({ loginError: true });

  changeUserType = prevValue => {
    const userType = prevValue === CONSTANTS.AUTH_SECONDARY_USER_TYPE ?
      CONSTANTS.AUTH_PRIMARY_USER_TYPE :
      CONSTANTS.AUTH_SECONDARY_USER_TYPE;
    this._NIFCOAuth.userType = userType;
    this.setState({ userTypeInputValue: userType });
  };

  handleInputChange = e => this.setState({ [e.target.name]: e.target.value });

  toggleColorScheme = () => {
    const newColorScheme = this.props.colorScheme === 'LIGHT' ? 'DARK' : 'LIGHT';
    // set color scheme in local storage
    localStorage.setItem(`com.nifconet.${CONSTANTS.APP_ID}.colorScheme`,newColorScheme);
    // set color scheme in props
    this.props.updateColorScheme(newColorScheme);
  };

  render() {
    const { loginError } = this.state;
    const { colorScheme, loadingMessage } = this.props;
    const {
      userTypeInputValue,
      usernameInputValue,
      passwordInputValue,
    } = this.state;
    const isLoading = loadingMessage != null;

    return (
      <div
        style={{
          ...styles.mainContainer,
          backgroundColor: GLOBAL_STYLES[colorScheme].bgColor,
          color: GLOBAL_STYLES[colorScheme].fgColor,
        }}
      >
        <img
          src={GLOBAL_STYLES[colorScheme].logo}
          alt={'NIFCO'}
          width={'284'}
          height={'132'}
          style={styles.logo}
        />
        <p style={styles.appTitle}>{`${CONSTANTS.APP_DISPLAY_NAME} v${getPackageVersion()}`}</p>
        <Form style={styles.form}>
          <Form.Group>
            <Form.Control
              type={'text'}
              style={
                loginError ?
                  styles.redBorder
                  :
                  null
              }
              placeholder={'Enter username'}
              value={usernameInputValue}
              name={'usernameInputValue'}
              onChange={this.handleInputChange}
              disabled={isLoading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type={'password'}
              style={
                loginError ?
                  styles.redBorder
                  :
                  null
              }
              placeholder={'Enter password'}
              value={passwordInputValue}
              name={'passwordInputValue'}
              onChange={this.handleInputChange}
              disabled={isLoading}
            />
          </Form.Group>
          {
            CONSTANTS.AUTH_SECONDARY_USER_TYPE != null ?
              (
                <Button
                  variant={'warning'}
                  type={'button'}
                  onClick={() => this.changeUserType(userTypeInputValue)}
                  disabled={isLoading}
                  style={styles.button}
                  className={'button-orange'}
                  block
                >
                  {userTypeInputValue}
                </Button>
              )
              :
              null
          }
          <Button
            variant={'warning'}
            type={'submit'}
            onClick={e => this.authenticatePasswordUser(e,usernameInputValue,passwordInputValue)}
            disabled={isLoading}
            style={styles.button}
            className={'button-orange'}
            block
          >
            LOGIN
          </Button>
        </Form>
        <i
          className="fa fa-lightbulb-o fa-2x"
          style={{
            ...styles.lightBulb,
            color: GLOBAL_STYLES[colorScheme].fgColor,
          }}
          onClick={this.toggleColorScheme}
        />
      </div>
    )
  }
}

const styles = {
  mainContainer: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '100px 10px 0 10px',
    margin: 0,
  },
  appTitle: {
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: 20,
    marginBottom: 30,
  },
  logo: {
    marginBottom: 15,
  },
  form: {
    width: 280,
  },
  redBorder: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: GLOBAL_STYLES.CONSTANTS.redColor,
  },
  button: {
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
  lightBulb: {
    position: 'absolute',
    top: 15,
    right: 20,
    cursor: 'pointer',
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(Login);